module.exports = __webpack_public_path__ + "static/media/distribution-supply-chain.1dd27cef.svg";